export default __webpack_public_path__ + "static/media/Arm-straps of Black Whispers.13c637c3.jpg";